import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import Stack from "@mui/material/Stack"
import TextField from "@mui/material/TextField"
import { Button } from "@cakemail-org/ui-components-v2"
import { useState } from "react"

export function SignInUp({ submitForm }: { submitForm: Function }) {
    const [email, setEmail] = useState<string>("")
    const [password, setPassword] = useState<string>("")

    function handleEmail(event: React.ChangeEvent<HTMLInputElement>) {
        setEmail(event.target.value)
    }

    function handlePassword(event: React.ChangeEvent<HTMLInputElement>) {
        setPassword(event.target.value)
    }

    return <Dialog open >
        <Stack padding={8} >
            <DialogTitle>Developpement sign in:</DialogTitle>
            <FormControl sx={{ mt: 2 }} onChange={handleEmail}>
                <FormLabel>User name</FormLabel>
                <TextField></TextField>
            </FormControl>
            <FormControl sx={{ mt: 2 }}>
                <FormLabel>password</FormLabel>
                <TextField type="password" onChange={handlePassword}></TextField>
            </FormControl>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => { submitForm(email, password) }}>Sign in</Button>
        </Stack>

    </Dialog>
}